import { Injectable } from '@angular/core';
import {User} from '../Models/user.model';
import {UserService} from './user.service';
import {AppConfig} from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public static user: User = new User();
  constructor(private userService: UserService,
              public config: AppConfig) {
    this.getUser();
  }
  user(): any{
    return SharedService.user;
  }
  getUser(): any {
      this.userService.getCurrentUserInfo().subscribe((data) => {
        SharedService.user = data;
        localStorage.setItem('username', data.name);
        localStorage.setItem('userOfId', data.id);
      }, (error) => {
        console.log(error);
      });
  }
}
